module.exports = __webpack_public_path__ + "img/logo-lfb-couleur-400x350.eae120a7.webp";